'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('dynamicYield/components/account'));

    // Trigger check for session error
    var globalErrorModal = require('./components/globalErrorModal');
    globalErrorModal.init();
});
